<template>
  <div>
    <div ref="headerFixed" class="shadow-sm bg-light">
      <b-container>
        <b-row align-h="center" class="py-2 mb-4">
          <b-col sm>
            <div id="brand-wrapper">
              <!-- <img id="brand-logo" src="../assets/logo.png" /> -->
              <!-- <img id="brand-logo" :src="require('../assets/logo.png')" /> -->
              <!-- :src="require(`@/assets/${image}.svg`)" -->
              <a href="#"
                ><img
                  id="brand-logo"
                  src="data:image/png;base64,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"
                  alt=""
              /></a>
              <span id="brand-title">{{
                this.GLOBAL_CONSTANTS.metaInfo.appName
              }}</span>
            </div>
          </b-col>
          <b-col xl="5">
            <b-input-group>
              <b-form-input
                v-model="corpus_id"
                placeholder="Enter Corpus ID"
              ></b-form-input>
              <b-input-group-append>
                <b-button
                  v-on:click="changeCorpus(corpus_id)"
                  :disabled="!validateCorpusId(corpus_id)"
                  variant="secondary"
                  >Fetch Corpus</b-button
                >
              </b-input-group-append>
            </b-input-group>
          </b-col>
          <b-col class="pt-2" sm>
            <span class="text-muted">or </span>
            <b-link v-on:click="createNewCorpus()" variant="primary">
              Create a New Corpus</b-link
            >
          </b-col>
        </b-row>
      </b-container>
    </div>

    <b-alert
      v-model="noCorpusId"
      class="position-fixed fixed-bottom m-0 rounded-0"
      style="z-index: 2000"
      variant="warning"
      dismissible
    >
      <b-container class="text-center">
        <b-row align-h="center">
          <b-col>
            Please enter a corpus ID to access your documents. You don't have a
            corpus ID ?
            <b-button
              v-on:click="createNewCorpus()"
              variant="primary"
              size="sm"
              class="mx-2 shadow"
            >
              Create a New Corpus</b-button
            >
            or
            <b-button
              v-on:click="createExampleCorpus()"
              variant="primary"
              size="sm"
              class="mx-2 shadow"
            >
              Load an Example</b-button
            >
          </b-col></b-row
        >
      </b-container>
    </b-alert>
  </div>
</template>

<script>
import requestsMixin from "../mixins/requestsMixin";
import messagesMixin from "../mixins/messagesMixin";
const imgLink = require("../assets/logo.png");

export default {
  name: "component-header",
  mixins: [requestsMixin, messagesMixin],
  data() {
    return {
      ro: null,
      corpus_id: "",
      logoPath: imgLink,
    };
  },
  methods: {
    /* -------------------------- Set Corpus ID Cookie -------------------------- */
    // Store corpus_id as browser cookie such that the corpus_id is not lost
    // after a simple refresh

    rememberCorpusId(corpus_id) {
      this.$cookies.set("corpus_id", corpus_id, Infinity);
    },

    recallCorpusId() {
      return this.$cookies.get("corpus_id");
    },

    /* ---------------------------- Switch Corpus ID ---------------------------- */
    // Tells other components about corpus_id change.

    changeCorpusId(corpus_id) {
      return new Promise((resolve, reject) => {
        if (this.validateCorpusId(corpus_id)) {
          this.corpus_id = corpus_id;
          this.$emit("changed_corpus_id", corpus_id);
          this.rememberCorpusId(corpus_id);
          // Return to the document list
          if (this.$route.name !== "home") {
            this.$router.push({ name: "home" });
          }

          resolve(corpus_id);
        } else {
          reject(new Error("Empty Corpus ID"));
        }
      });
    },

    /* ------------------------------ Switch Corpus ----------------------------- */
    // Used if user enters a different but already existing corpus_id.

    changeCorpus(corpus_id) {
      this.changeCorpusId(corpus_id).catch((error) => {
        console.log(error);
        this.showToast("Corpus could not be fetched", String(error), "danger");
      });
    },

    /* ----------------------- Create New and Empty Corpus ---------------------- */
    // request new corpus_id, insert blank document and store corpus_id as cookie

    createNewCorpus() {
      // Insert new corpus object in DB
      this.getNewCorpusId()
        .then((corpus_id) => {
          return this.insertBlankDocument(
            corpus_id,
            "This is your first document. Have fun!"
          );
        })
        // Save new corpus id
        .then((response) => {
          return this.changeCorpusId(response.data.corpus_id);
        })
        // Show success message
        .then(() => {
          this.showToast(
            "New corpus created",
            "Please save the corpus ID. You can use it to \
            return to your corpus later or to share it with others.",
            "success",
            { autoHideDelay: 10000 }
          );
        })
        // Show error message
        .catch((error) => {
          console.log(error);
          this.showToast(String(error.message), String(error.cause), "danger");
        });
    },

    /* -------------------------- Create Example Corpus ------------------------- */
    // Request new corpus_id, insert example documents and store corpus_id as cookie

    createExampleCorpus() {
      this.getNewCorpusId()
        .then((corpus_id) => {
          return this.insertExampleDocuments(corpus_id);
        })
        .then((response) => {
          return this.changeCorpusId(response.data.corpus_id);
        })
        .then(() => {
          // return to the document list
          if (this.$route.name !== "home") {
            this.$router.push({ name: "home" });
          }
        })
        .catch((error) => {
          console.log(error);
          this.showToast(
            "Example corpus could not be created!",
            String(error),
            "danger"
          );
        });
    },

    onResize() {
      //console.log(this.$refs.headerFixed.offsetHeight);
      this.$emit("changed_height", this.$refs.headerFixed.offsetHeight);
    },
  },
  computed: {
    // Check if a corpus_id was intered;
    // if not, display an alert with suggestions
    noCorpusId: function () {
      return !this.validateCorpusId(this.corpus_id);
    },
  },
  mounted() {
    // Check if cooky with corpus_id is present;
    // If so, use this corpus_id as current id
    let previousCorpusId = this.recallCorpusId();
    if (!!previousCorpusId) {
      this.changeCorpus(previousCorpusId);
    }

    this.ro = new ResizeObserver(this.onResize).observe(this.$refs.headerFixed);
  },

  // beforeDestroy() {
  //   this.ro.unobserve(this.$refs.headerFixed);
  // },
};
</script>

<style scoped>
#brand-wrapper {
  line-height: 35px;
  vertical-align: middle;
}

#brand-logo {
  height: 21.5px;
  vertical-align: middle;
}

#brand-title {
  vertical-align: middle;
}
</style>


// WEBPACK FOOTER //
// src/components/header.vue